export default __webpack_public_path__ + "static/media/Awards_Shapes-01.9dbc265a.png";